import { FC } from "react";
import { Flex, Box, Text } from "@smile2impress/components/relaunch";
import { Icon, Icons } from "@smile2impress/components";
import { UniversalTextElement } from "templates/relaunch/primitives/UniversalTextElement";

import { ListItemProps } from "./ListItem.types";

export const ListItem: FC<ListItemProps> = ({ title, text, icon, index }) => {
    const iconComponent =
        typeof icon === "string" ? Icons[icon as keyof typeof Icons] : icon;
    const withNumber = typeof index !== "undefined";

    return (
        <Flex direction={["row-reverse", "row-reverse", "column"]} gap={1}>
            {iconComponent && (
                <Flex>
                    <Icon
                        w={3}
                        h={3}
                        as={iconComponent}
                        color="base.bitterSweet"
                    />
                </Flex>
            )}
            {!iconComponent && withNumber && (
                <Flex>
                    <Box
                        border="2px solid"
                        borderColor="base.bitterSweet"
                        alignSelf="flex-start"
                        w={["32px"]}
                        h={["32px"]}
                        borderRadius="xl"
                        textAlign="center"
                    >
                        <Text
                            color="base.bitterSweet"
                            lineHeight={["28px"]}
                            fontSize={["14px"]}
                        >
                            {index + 1}
                        </Text>
                    </Box>
                </Flex>
            )}
            <UniversalTextElement
                title={title}
                text={text}
                extraTitleStyles={{
                    fontWeight: "medium",
                    textTransform: "uppercase",
                    as: "h3",
                }}
            />
        </Flex>
    );
};
